module.exports = __webpack_public_path__ + "img/0Q3B3739.ae42c3a2.webp";